/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2019, 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

export const FETCH_ALL_INTENT_CONFLICTS =
  'conversation/conflicts/fetch-all-intent-conflicts-start';
export const FETCH_ALL_INTENT_CONFLICTS_SUCCESS =
  'conversation/conflicts/fetch-all-intent-conflicts-success';
export const FETCH_ALL_INTENT_CONFLICTS_ERROR =
  'conversation/conflicts/fetch-all-intent-conflicts-error';

export const FETCH_SINGLE_INTENT_CONFLICTS =
  'conversation/conflicts/fetch-single-intent-conflicts-start';
export const FETCH_SINGLE_INTENT_CONFLICTS_SUCCESS =
  'conversation/conflicts/fetch-single-intent-conflicts-success';
export const FETCH_SINGLE_INTENT_CONFLICTS_ERROR =
  'conversation/conflicts/fetch-single-intent-conflicts-error';

export const FETCH_INTENT_EXAMPLE_CONFLICTS =
  'conversation/conflicts/fetch-example-conflicts-start';
export const FETCH_INTENT_EXAMPLE_CONFLICTS_SUCCESS =
  'conversation/conflicts/fetch-example-conflicts-success';
export const FETCH_INTENT_EXAMPLE_CONFLICTS_ERROR =
  'conversation/conflicts/fetch-example-conflicts-error';
